// Tasas de IVA que puede llevar una línea de factura: 22 (básica), 10 (mínima) o 0 (exento).
export const DEFAULT_IVA_RATE = 22;
export const IVA_RATE_OPTIONS = [
  { value: 22, label: "22%" },
  { value: 10, label: "10%" },
  { value: 0, label: "Exento" },
];

// Una tasa desconocida o ausente cae en la básica, igual que el backend.
export const lineIvaRate = (line) =>
  (IVA_RATE_OPTIONS.some((option) => option.value === Number(line.ivaRate)) ? Number(line.ivaRate) : DEFAULT_IVA_RATE);

// Los precios ya incluyen IVA: cada línea aporta según su propia tasa.
export const includedIva = (lines, lineTotal) =>
  lines.reduce((sum, line) => {
    const total = lineTotal(line);
    return sum + (total - total / (1 + lineIvaRate(line) / 100));
  }, 0);
